/**
 * @module registration/creative/components/substep2_2
 */

import React, { Component, PropTypes } from 'react';
import AnimatedButton from 'common/components/animated_button';
import IdCapture from 'registration/creative/containers/id_capture';
import WaitIdCapture from 'registration/creative/containers/wait_id_capture';
import ValidationMethods from 'registration/creative/components/phone_validation_methods';
import { isPhoneValid } from 'common/utils';
import { DEFAULT_REQUIRED_MESSAGE, PHONE_INVALID_MESSAGE } from 'common/components/form_fields';

/**
 * Substep 2.2 of creative registration.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class Substep2_2 extends Component {
  constructor(props) {
    super(props)
    this.state = { method: 'smartphone', phone: '', code: '', phoneError: '' }
    this.next = this.next.bind(this)
    this.updatePhone = this.updatePhone.bind(this)
    this.verifyCode = this.verifyCode.bind(this)
    this.handleChangePhone = this.handleChangePhone.bind(this)
    this.handleBlurPhone = this.handleBlurPhone.bind(this)
    this.validatePhone = this.validatePhone.bind(this)
  }

  componentDidMount() {
    const { idValidated, nextSubstep } = this.props;

    if (idValidated) {
      nextSubstep();
    }
  }

  validatePhone(value) {
    if (!value) return DEFAULT_REQUIRED_MESSAGE;
    if (!isPhoneValid(value)) return PHONE_INVALID_MESSAGE
  }

  handleChangePhone(value) {
    this.setState({ phone: value, phoneError: this.validatePhone(value) });
  }

  handleBlurPhone() {
    this.setState({ phoneError: this.validatePhone(this.state.phone) });
  }

  verifyCode() {
    this.props.verifyPhoneByCode(this.state.code)
  }

  next() {
    /* If the non-smartphone method was chosen, validate SMS code. Otherwise (smartphone method),
       send link to user's mobile device via SMS. */
    if (this.state.method == 'smartphone') {
      this.updatePhone()
    } else {
      this.verifyCode()
    }
  }

  updatePhone() {
    const { method, phone } = this.state
    this.props.updateMobilePhone(phone, method == "smartphone")
  }

  renderValidationMethods() {
    const { method, phone, code, phoneError } = this.state
    const { user } = this.props
    const nextDisabled = (
      method == 'none'
      || (method == 'smartphone' && (!!phoneError || !phone))
      || (method == 'non-smartphone' && !code)
    )
    const processing = method == 'smartphone'? user.updatingMobile:user.verifyingMobile
    const processingLabel = method == "non-smartphone"? "Verifying..." : "Sending link..."

    return (
      <div className="columns small-16 medium-10">
        <div className="step-header">
          <h2>Verify Your ID</h2>
          <p className="step-instructions">
            To protect clients and creatives, and to maintain our reputation as the
            most trusted design and naming marketplace, we verify the identity of every person
            who wants to work on crowdspring.
          </p>
        </div>

        <ValidationMethods method={method} phone={phone} code={code} user={user}
          onChangeMethod={(m) => this.setState({method: m})}
          onChangeCode={(c) => this.setState({code: c})}
          onChangePhone={this.handleChangePhone}
          onBlurPhone={this.handleBlurPhone}
          updatePhone={this.updatePhone}
          phoneError={phoneError} />

        <div className="text-left">
          <AnimatedButton processing={processing} label="Next" processingLabel={processingLabel}
            baseBtnClass="btn-tertiary btn-block" errorMsg={user.error} successMsg="Done!"
            onClick={this.next} disabled={nextDisabled}/>
        </div>

        <p className="disclaimer">
          By entering your mobile phone number, you agree that crowdspring
          may<br className="hide-for-small-only" /> send you an SMS message.
          Standard messaging rates may apply.
        </p>
      </div>)
  }

  renderContent() {
    const { user, resumedFromMagicLink, nextSubstep, reviewing } = this.props;

    /* Wait until the ID capturing process is completed on user's mobile device. */
    if (user.mobileUpdatedSmart) {
     return <WaitIdCapture onComplete={nextSubstep} />
    }

    /* Capture ID photo and selfie here */
    if (user.mobileValidated || resumedFromMagicLink || reviewing) {
      return <IdCapture onComplete={nextSubstep}/>
    }

    /* Validation methods */
    return this.renderValidationMethods()
  }

  render() {
    return (
      <div className="substep2-2">
        <div className="row align-center">
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

Substep2_2.propTypes = {
  user: PropTypes.object.isRequired,
  reviewing: PropTypes.bool,
  idValidated: PropTypes.bool,
  resumedFromMagicLink: PropTypes.bool,
  nextSubstep: PropTypes.func.isRequired,
  updateMobilePhone: PropTypes.func.isRequired,
  verifyPhoneByCode: PropTypes.func.isRequired,
};

export default Substep2_2;



// WEBPACK FOOTER //
// ./registration/creative/components/substep2_2.jsx